import { render, staticRenderFns } from "./LogisticsInfo.vue?vue&type=template&id=fffede9e&scoped=true"
import script from "./LogisticsInfo.vue?vue&type=script&lang=js"
export * from "./LogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInfo.vue?vue&type=style&index=0&id=fffede9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffede9e",
  null
  
)

export default component.exports